<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <h4 class="col-md-1">起始時間：</h4>
        <DateSelect ref="startTime" :isTransactionList="true" />
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <h4 class="col-md-1">結束時間：</h4>
        <DateSelect ref="endTime" :isTransactionList="true" :isEndTime="true" />
      </div>
    </div>
    <div class="row">
      <div class="col-md-5">
        <h4 class="col-md-3" style="max-width: 123.9px">搜尋關鍵字:</h4>
        <input
          v-model="kw"
          type="text"
          required="required"
          class="inputstyle col-md-7 fontSize16"
          placeholder="隊編/呼號、乘客電話、車牌、上車地址、備註"
          style="margin-left: 5px"
        />
        <button type="button" class="mybtnstyle btn-success" @click="onSearch">
          搜尋
        </button>
      </div>
      <div class="col-md-2">
        <h4 class="col-md-12">
          <i class="fa fa-user" />
          派車單總數:
          <span class="red_textcolor">
            {{ billCount }}
          </span>
        </h4>
      </div>
    </div>
    <el-row style="margin-bottom: 1rem">
      <el-col :span="8" :offset="2">
        <el-radio-group v-model="rule" @input="onRule" class="pick">
          <el-radio :label="0">查全部</el-radio>
          <el-radio v-show="vx_activeTab !== 'reserveAfter'" :label="1">
            只查呼號
          </el-radio>
          <el-radio v-show="vx_activeTab !== 'road'" :label="2">
            只查電話
          </el-radio>
          <el-radio v-show="vx_activeTab !== 'reserveAfter'" :label="3">
            只查車牌
          </el-radio>
        </el-radio-group>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import dayjs from 'dayjs'
import { Notification } from 'element-ui'
import DateSelect from '@/components/tool/DateSelect'

export default {
  components: {
    DateSelect,
  },
  data() {
    return {
      kw: '',
      rule: 0,
    }
  },
  computed: {
    ...mapState('transaction', {
      vx_activeTab: 'activeTab',
      vx_instantPaging: 'instantPaging',
      vx_roadPaging: 'roadPaging',
      vx_reserveBeforePaging: 'reserveBeforePaging',
      vx_reserveAfterPaging: 'reserveAfterPaging',
      vx_airportTransferPaging: 'airportTransferPaging',
    }),
    billCount() {
      if (this.vx_activeTab === 'instant') {
        return this.vx_instantPaging.totalEntries
      } else if (this.vx_activeTab === 'road') {
        return this.vx_roadPaging.totalEntries
      } else if (this.vx_activeTab === 'reserveBefore') {
        return this.vx_reserveBeforePaging.totalEntries
      } else if (this.vx_activeTab === 'reserveAfter') {
        return this.vx_reserveAfterPaging.totalEntries
      } else if (this.vx_activeTab === 'airport') {
        return this.vx_airportTransferPaging.totalEntries
      }
    },
  },
  methods: {
    ...mapMutations('transaction', {
      vx_setTab: 'setTab',
      vx_setKw: 'setKw',
      vx_setRule: 'setRule',
      vx_setSearchStart: 'setSearchStart',
      vx_setSearchEnd: 'setSearchEnd',
      vx_setInstantPagingCurrentPage: 'setInstantPagingCurrentPage',
      vx_setRoadPagingCurrentPage: 'setRoadPagingCurrentPage',
      vx_setReserveBeforePagingCurrentPage: 'setReserveBeforePagingCurrentPage',
      vx_setReserveAfterPagingCurrentPage: 'setReserveAfterPagingCurrentPage',
      vx_setAirportTransferPagingCurrentPage:
        'setAirportTransferPagingCurrentPage',
    }),
    ...mapActions('transaction', {
      vx_fetchList: 'fetchList',
    }),
    toPageOne() {
      this.vx_setInstantPagingCurrentPage(1)
      this.vx_setRoadPagingCurrentPage(1)
      this.vx_setReserveBeforePagingCurrentPage(1)
      this.vx_setReserveAfterPagingCurrentPage(1)
      this.vx_setAirportTransferPagingCurrentPage(1)
    },
    onSearch() {
      const start = this.$refs.startTime.getDate()
      const end = this.$refs.endTime.getDate()
      if (dayjs(end).isAfter(start)) {
        // 取得start end 時間的timestamp
        const startTimestamp = new Date(start).getTime()
        const endTimestamp = new Date(end).getTime()
        this.vx_setKw(this.kw)
        this.vx_setSearchStart(startTimestamp)
        this.vx_setSearchEnd(endTimestamp)
        this.toPageOne()
        this.vx_fetchList()
      } else {
        Notification({
          title: '時間錯誤',
          message: '請選擇正確的時間，且結束的時間須大於起始的時間',
          type: 'warning',
        })
      }
    },
    onRule() {
      this.vx_setRule(this.rule)
    },
  },
  created() {
    this.unwatch = this.$store.watch(
      (state) => state.transaction.rule,
      (newRule) => {
        this.rule = newRule
      },
    )
  },
  beforeDestroy() {
    this.unwatch()
  },
}
</script>



// WEBPACK FOOTER //
// src/pages/transaction/components/Search.vue